import { render, staticRenderFns } from "./CodingRuleDetailEdit.vue?vue&type=template&id=d50d5648"
import script from "./CodingRuleDetailEdit.vue?vue&type=script&lang=js"
export * from "./CodingRuleDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports